import { ScaleType,ScaleConfig,ZoneLevel } from "./range-scale.model";

export const scaleConfig: Record<ScaleType, ScaleConfig> = {
  [ScaleType.Ph]: {
    title: 'lang.ph_scale',
    description: 'lang.ph_scale_description',
    scaleTitle: 'lang.ph_scale_title',
    min: 7.0,
    max: 7.8,
    step: 0.2,
    zones: [
      { min: 7.0, max: 7.8, level: ZoneLevel.Danger },
      { min: 7.1, max: 7.7, level: ZoneLevel.Warning },
      { min: 7.2, max: 7.6, level: ZoneLevel.Safe },
    ],
  },
  [ScaleType.Salt]: {
    title: 'lang.salt_range',
    description: 'lang.salt_range_description',
    scaleTitle: 'lang.salt_scale_title',
    min: 2000,
    max: 4500,
    step: 500,
    zones: [
      { min: 2000, max: 4500, level: ZoneLevel.Danger },
      { min: 2500, max: 4000, level: ZoneLevel.Warning },
      { min: 3000, max: 3500, level: ZoneLevel.Safe },
    ],
  },
  [ScaleType.Orp]: {
    title: 'lang.orp_range',
    description: 'lang.orp_range_description',
    min: 500,
    max: 1000,
    step: 50,
    zones: [
      { min: 500, max: 1000, level: ZoneLevel.Danger },
      { min: 550, max: 900, level: ZoneLevel.Warning },
      { min: 650, max: 800, level: ZoneLevel.Safe },
    ],
  },
};